import type { Step } from "react-joyride";

export const auditSummaryTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າສະຫຼຸບຜົນການກວດສອບ! ຫນ້ານີ້ຈະສະແດງພາບລວມຂອງການກວດສອບພາຍໃນ, ລວມທັງສະຖິຕິ, ແນວໂນ້ມ, ແລະບັນຫາທີ່ຕ້ອງແກ້ໄຂ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="summary-filter"]',
    content:
      "ນີ້ແມ່ນຕົວກອງຂໍ້ມູນ. ທ່ານສາມາດເລືອກຊ່ວງວັນທີ (ເລືອກວັນທີເລີ່ມຕົ້ນແລະວັນທີສິ້ນສຸດໃນຄັ້ງດຽວ) ແລະເລືອກພະແນກທີ່ຕ້ອງການ. ຫຼັງຈາກເລືອກແລ້ວ, ກົດປຸ່ມ 'ນຳໃຊ້' ເພື່ອເບິ່ງຂໍ້ມູນຕາມການກອງທີ່ເລືອກ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="summary-stats-cards"]',
    content:
      "ນີ້ແມ່ນຂໍ້ມູນສະຖິຕິພາບລວມ. ທ່ານຈະເຫັນຈຳນວນການກວດສອບທັງໝົດ, ຈຳນວນທີ່ຜ່ານ, ຈຳນວນທີ່ບໍ່ຜ່ານ, ຈຳນວນທີ່ຕ້ອງປັບປຸງ, ແລະຈຳນວນບັນຫາທີ່ຍັງບໍ່ແກ້ໄຂ. ຂໍ້ມູນເຫຼົ່ານີ້ຈະຊ່ວຍໃຫ້ທ່ານເຂົ້າໃຈພາບລວມຂອງການກວດສອບໄດ້ຢ່າງໄວ.",
    placement: "top",
  },
  {
    target: '[data-tourid="summary-charts"]',
    content:
      "ນີ້ແມ່ນແຜນພາບອັດຕາສ່ວນ ຜ່ານ/ບໍ່ຜ່ານ. ທ່ານຈະເຫັນອັດຕາສ່ວນຂອງການກວດສອບທີ່ຜ່ານ, ບໍ່ຜ່ານ, ແລະຕ້ອງປັບປຸງ. ແຜນພາບນີ້ຈະຊ່ວຍໃຫ້ທ່ານເຫັນພາບລວມຂອງຜົນການກວດສອບໄດ້ຢ່າງຊັດເຈນ.",
    placement: "top",
  },
  {
    target: '[data-tourid="summary-period-comparison"]',
    content:
      "ນີ້ແມ່ນການປຽບທຽບລະຫວ່າງລະດູການ. ທ່ານຈະເຫັນການປ່ຽນແປງຂອງຈຳນວນການກວດສອບ, ອັດຕາຜ່ານ, ແລະຈຳນວນບັນຫາໃນລະດູການປັດຈຸບັນເມື່ອທຽບກັບລະດູການກ່ອນໜ້ານີ້. ສັນຍານລູກສອນຂຶ້ນ/ລົງຈະສະແດງວ່າມີການປັບປຸງຫຼືບໍ່.",
    placement: "top",
  },
  {
    target: '[data-tourid="summary-trends"]',
    content:
      "ນີ້ແມ່ນແນວໂນ້ມການກວດສອບໃນ 12 ເດືອນຜ່ານມາ. ທ່ານຈະເຫັນຈຳນວນການກວດສອບແລະອັດຕາຜ່ານໃນແຕ່ລະເດືອນ. ແຜນພາບນີ້ຈະຊ່ວຍໃຫ້ທ່ານເຫັນແນວໂນ້ມການປັບປຸງຫຼືການເພີ່ມຂຶ້ນຂອງບັນຫາ.",
    placement: "top",
  },
  {
    target: '[data-tourid="summary-frequently-failed"]',
    content:
      "ນີ້ແມ່ນລາຍການເລື່ອງທີ່ບໍ່ຜ່ານບໍ່. ທ່ານຈະເຫັນລາຍການຂອງລາຍການກວດສອບທີ່ບໍ່ຜ່ານບໍ່ເລື້ອຍໆ, ພ້ອມກັບຈຳນວນຄັ້ງທີ່ບໍ່ຜ່ານແລະອັດຕາສ່ວນ. ຂໍ້ມູນນີ້ຈະຊ່ວຍໃຫ້ທ່ານກຳນົດຈຸດທີ່ຕ້ອງປັບປຸງ.",
    placement: "top",
  },
  {
    target: '[data-tourid="summary-departments"]',
    content:
      "ນີ້ແມ່ນລາຍການພະແນກທີ່ມີບັນຫາຊ້ຳຊ້ອນ. ທ່ານຈະເຫັນພະແນກທີ່ມີບັນຫາຫຼາຍທີ່ສຸດ, ພ້ອມກັບຈຳນວນບັນຫາທັງໝົດແລະຈຳນວນບັນຫາທີ່ຍັງບໍ່ແກ້ໄຂ. ກົດປຸ່ມ 'ເບິ່ງບັນຫາ' ເພື່ອເບິ່ງລາຍລະອຽດບັນຫາຂອງພະແນກນັ້ນ.",
    placement: "top",
  },
];

